import { GiftCsMemoLogItem } from '@shared/api/giftCsMemo/giftCsMemo.interface';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';

// CS 응대 로그 엑셀 — 응대 매뉴얼·교육자료로 뽑아 쓰는 용도.
// 프로젝트 표준(커뮤니티 xlsx + file-saver)만 사용하고, 스타일 대신 너비·고정·필터로 읽히게 한다.

const fmt = (date: Date | string | undefined) => {
  if (!date) return '';
  const d = new Date(date);
  const p = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())} ${p(
    d.getHours(),
  )}:${p(d.getMinutes())}`;
};

const targetLabel = (item: GiftCsMemoLogItem) =>
  item.giftCoupon ? '쿠폰' : item.giftDelivery ? '배송' : '주문';

const targetCode = (item: GiftCsMemoLogItem) => {
  if (item.coupon) {
    return (
      item.coupon.fullCode ??
      [item.coupon.code, item.coupon.seq].filter(Boolean).join('-')
    );
  }
  if (item.delivery) return item.delivery.code ?? '';
  return '';
};

export const exportCsMemoLogExcel = (
  items: GiftCsMemoLogItem[],
  range: { from: string; to: string },
) => {
  const rows = items.map((item) => ({
    작성일시: fmt(item.createdAt),
    작성자: item.byName,
    역할: item.byRole === 'Admin' ? '관리자' : '마리',
    공개범위: item.adminOnly ? '관리자 전용' : '공유',
    단위: targetLabel(item),
    대상코드: targetCode(item),
    상품: item.coupon?.itemName ?? '',
    주문자: item.order?.receiverName ?? '',
    주문자연락처: item.order?.receiverPhoneNumber ?? '',
    내용: item.body,
  }));

  const ws = XLSX.utils.json_to_sheet(rows);
  ws['!cols'] = [
    { wch: 18 }, // 작성일시
    { wch: 10 }, // 작성자
    { wch: 8 }, // 역할
    { wch: 12 }, // 공개범위
    { wch: 6 }, // 단위
    { wch: 16 }, // 대상코드
    { wch: 24 }, // 상품
    { wch: 10 }, // 주문자
    { wch: 15 }, // 주문자연락처
    { wch: 80 }, // 내용
  ];
  ws['!freeze'] = { xSplit: '0', ySplit: '1' };
  if (rows.length > 0) {
    ws['!autofilter'] = { ref: XLSX.utils.encode_range({ s: { r: 0, c: 0 }, e: { r: rows.length, c: 9 } }) };
  }

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'CS응대로그');
  const buf = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
  saveAs(
    new Blob([buf], { type: 'application/octet-stream' }),
    `CS응대로그_${range.from}_${range.to}.xlsx`,
  );
};
